// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1C6Em","boxTitle":"Qualiphy_boxTitle__2cZ7n","box":"Qualiphy_box___K1YE","toggleWrap":"Qualiphy_toggleWrap__3kbeL"};